import FacetTypes from '@/types/search/enums/facetTypes';
import ParamTypes from '@/types/search/enums/paramTypes';
import { FilterAction } from '@/types/SearchFacet';

// This is used to get the filter action by facet id for amplitude filter tracking events
export const getFilterActionByFacetId = ({
    facetId,
    isRemovingFilter,
}: {
    facetId: string | typeof ParamTypes;
    isRemovingFilter: boolean;
}) => {
    switch (facetId) {
        case FacetTypes.AUCTION_HOUSE_ID:
            return isRemovingFilter ? FilterAction.AuctionHouseRemoved : FilterAction.AuctionHouseChanged;
        case FacetTypes.MATERIALS_AND_TECHNIQUES_ID:
            return isRemovingFilter
                ? FilterAction.MaterialsAndTechniquesRemoved
                : FilterAction.MaterialsAndTechniquesChanged;
        case FacetTypes.CREATOR_ID:
            return isRemovingFilter ? FilterAction.CreatorRemoved : FilterAction.CreatorChanged;
        case FacetTypes.STYLE_PERIOD_ID:
            return isRemovingFilter ? FilterAction.StylePeriodRemoved : FilterAction.StylePeriodChanged;
        case FacetTypes.CATEGORY_ID:
            return isRemovingFilter ? FilterAction.CategoryRemoved : FilterAction.CategoryChanged;
        case FacetTypes.ORIGIN_ID:
            return isRemovingFilter ? FilterAction.OriginRemoved : FilterAction.OriginChanged;
        case FacetTypes.COUNTRY_CODE_ID:
            return isRemovingFilter ? FilterAction.LocationRemoved : FilterAction.LocationChanged;
        case FacetTypes.CURRENT_BID_ID:
            return isRemovingFilter ? FilterAction.CurrentBidRemoved : FilterAction.CurrentBidChanged;
        case FacetTypes.ESTIMATED_PRICE_ID:
            return isRemovingFilter ? FilterAction.PriceRangeRemoved : FilterAction.PriceRangeChanged;
        case FacetTypes.HAMMER_PRICE_ID:
            return isRemovingFilter ? FilterAction.HammerPriceRemoved : FilterAction.HammerPriceChanged;
        case FacetTypes.SALE_TYPE_ID:
            return isRemovingFilter ? FilterAction.BuyingFormatRemoved : FilterAction.BuyingFormatChanged;
        case FacetTypes.SHIPPING:
            return isRemovingFilter ? FilterAction.ShippingRemoved : FilterAction.ShippingChanged;
        case FacetTypes.TOP_RATED_ID:
            return isRemovingFilter ? FilterAction.RatingRemoved : FilterAction.RatingChanged;
        case FacetTypes.PAYMENT:
            return isRemovingFilter ? FilterAction.BuyingFormatRemoved : FilterAction.BuyingFormatChanged;
        case FacetTypes.KEYWORD_ID:
            return isRemovingFilter ? FilterAction.FilterTermRemoved : FilterAction.FilterTermAdded;

        default:
            // Dynamic facets (Attrs.* from elastic) use generic filter actions
            return isRemovingFilter ? FilterAction.AttrFacetRemoved : FilterAction.AttrFacetChanged;
    }
};
